import React from 'react';
import NotesManager from './NotesManager';

/**
 * Page de notes - Utilise le nouveau système centralisé avec MongoDB
 * Toutes les notes sont maintenant stockées de manière persistante dans la base de données
 */
const NotesPage = ({ onGoBack }) => {
  return <NotesManager context="Notes Générales" onClose={onGoBack} />;
};

export default NotesPage;
